export default "__VITE_ASSET__BU7C0YgY__"